export default "__VITE_ASSET__DxfyNLfa__"